import * as BufferGeometryUtils from "three/addons/utils/BufferGeometryUtils.js";
import * as THREE from "three";
import { globalData } from "../../helpers/globData.ts";
import { OBJLoader } from "three/addons/loaders/OBJLoader.js";
import { STLLoader } from "three/addons/loaders/STLLoader.js";
import { runDiffViewer } from "../../helpers/gingivaDiffReader.js";
import { numberingFdi } from "../../helpers/teethNumbering.js";
import { SingletonManager } from "../../helpers/singletonInitializer.ts";

export const GLBDataV2 = {
  rootGLB: {},
  baseTeethGLB: {},
  baseGumsGLB: {},
  baseAttGLB: {},
  isReady: false,
};
function assignRootGLB(rootModel) {
  GLBDataV2.rootGLB = rootModel;
}
function assignBaseTeethGLB(baseTeethModel) {
  GLBDataV2.baseTeethGLB = baseTeethModel;
}
function assignBaseGumsGLB(baseGumModel) {
  GLBDataV2.baseGumsGLB = [
    { isLower: false, bufferGeometry: baseGumModel[0] },
    { isLower: true, bufferGeometry: baseGumModel[1] },
  ];
}
function assignBaseGumsDiff(baseGumsDiffResult) {
  GLBDataV2.baseGumsDiff = baseGumsDiffResult;
}

/**
 *
 * @param {Mesh[]} baseTeeth teeth as Mesh[]
 */

export function assignBaseTeethGLB1(baseTeeth) {
  const baseTeethResult = [];
  let tooth;
  let toothNumber;
  for (let toothIndex = 1; toothIndex <= 32; toothIndex++) {
    tooth = baseTeeth[toothIndex - 1];
    if (!tooth) {
      continue;
    }
    toothNumber = parseInt(tooth.name.split("_")[2].substring(1, 5));
    tooth.geometry.computeVertexNormals();

    baseTeethResult.push({
      index: toothNumber,
      bufferGeometry: tooth.geometry,
    });
  }
  GLBDataV2.baseTeethGLB = baseTeethResult;
}

export function assignBaseAtt(attachmentParent) {
  attachmentParent?.children.forEach(attachment => {
    attachment.geometry.computeVertexNormals();
    attachment.material =
      SingletonManager.materialManager.getMaterial("attachmentMaterial");
    attachment.userData["type"] = "old";
    GLBDataV2.baseAttGLB[attachment.name] = attachment;
  });
}

export async function startMeshOrganisingLocally(model) {
  fillTreatmentData(model);
  await Promise.all([
    loadRootSimLocalModels("case/CaseRA/Root1/", "22RA", assignRootGLB),
    loadBaseTeethLocalModels("case/CaseSA/Base/Teeth1/", assignBaseTeethGLB),
    loadBaseGumsLocalModels("case/CaseSA/Base/Gum1/", assignBaseGumsGLB),
    loadGumDiffFiles("case/CaseSA/Base/Gum/Diff1/", assignBaseGumsDiff),
  ]);
  GLBDataV2.isReady = true;
  return GLBDataV2;
}

async function loadRootSimLocalModels(path, postKey, postProcessFunc) {
  const startTime = Date.now();
  if (false) {
    const key = `${path}SimRoots-${postKey}_Crown `;
    ////////////////////////////////////////////////////////////

    const quadrants = [
      { start: 11, end: 18 }, // Upper right
      { start: 21, end: 28 }, // Upper left
      { start: 31, end: 38 }, // Lower left
      { start: 41, end: 48 }, // Lower right
    ];
    const urls = [];
    quadrants.forEach(quadrant => {
      for (
        let toothNumber = quadrant.start;
        toothNumber <= quadrant.end;
        toothNumber++
      ) {
        urls.push({
          url: key + toothNumber + ".stl",
          toothNum: numberingFdi[toothNumber].universal,
        });
      }
    });

    const loader = new STLLoader();
    const promises = urls.map(
      (url, index) =>
        new Promise(resolve => {
          loader.load(
            url.url,
            bufferGeometry => {
              // Add the loaded model to the scene

              bufferGeometry.deleteAttribute("normal");
              bufferGeometry =
                BufferGeometryUtils.mergeVertices(bufferGeometry);
              bufferGeometry.computeVertexNormals();
              if (bufferGeometry) {
                resolve({
                  index: url.toothNum,
                  bufferGeometry: bufferGeometry,
                });
              } else {
                return;
                // console.log("File does not exist", url);
              }
            },
            undefined,
            error => {
              resolve(undefined);
              // console.log("File does not exist", url, error);
            },
          );
        }),
    );

    ///////////////////////////////////////////////////////////
    Promise.all(promises)
      .then(model => {
        console.log("roots time", Date.now() - startTime);

        postProcessFunc(model);
      })
      .catch(error => console.error("Loading failed:", error));
  } else {
    const array = [];
    for (let toothUniNum = 1; toothUniNum <= 32; toothUniNum++) {
      array.push(undefined);
    }
    console.log("roots time", Date.now() - startTime);
    postProcessFunc(array);
  }
}

async function loadBaseTeethLocalModels(path, postProcessFunc) {
  const startTime = Date.now();
  if (false) {
    const key = `${path}{Orthodontics.Semantics.Models.SimpleTeeth.Jaw.`;
    ////////////////////////////////////////////////////////////

    const urls = [];
    for (let toothUniNum = 1; toothUniNum < 32; toothUniNum++) {
      urls.push(
        key + `${toothUniNum > 16 ? "Lower" : "Upper"}}` + toothUniNum + ".obj",
      );
    }
    const loader = new OBJLoader();
    const promises = urls.map(
      (url, index) =>
        new Promise(resolve => {
          loader.load(
            url,
            group => {
              // Add the loaded model to the scene
              if (group.children[0].geometry.attributes.normal.array[0]) {
                resolve({
                  index: index + 1,
                  bufferGeometry: group.children[0].geometry,
                });
              } else {
                resolve(undefined);
                return;
                console.log("File does not exist", url);
              }
            },
            undefined,
            error => {
              resolve(undefined);
              // console.log("File does not exist", url, error);
            },
          );
        }),
    );

    ///////////////////////////////////////////////////////////
    Promise.all(promises)
      .then(model => {
        console.log("Teeth time", Date.now() - startTime);
        GLBDataV2.isReady = true;
        postProcessFunc(model);
      })
      .catch(error => console.error("Loading failed:", error));
  } else {
    const array = [];
    for (let toothUniNum = 1; toothUniNum < 32; toothUniNum++) {
      array.push(undefined);
    }

    postProcessFunc(array);
    console.log("Teeth time", Date.now() - startTime);
  }
}

async function loadBaseGumsLocalModels(path, postProcessFunc) {
  const startTime = Date.now();
  ////////////////////////////////////////////////////////////
  const urls = [`${path}GingivaModelUpper.obj`, `${path}GingivaModelLower.obj`];
  if (false) {
    const loader = new OBJLoader();
    const promises = urls.map(
      (url, index) =>
        new Promise(resolve => {
          fetch(url)
            .then(response => response.text())
            .then(objText => {
              const { positions, normals, faces } = parseOBJ(objText);

              // You can now create a custom Three.js geometry out of these arrays
              // or do anything else with the raw data.

              // Example: building a BufferGeometry (note: you'd have to expand
              // the face indices properly into a flat array or an index buffer).
              const geometry = new THREE.BufferGeometry();

              // Flatten position arrays: [x0,y0,z0, x1,y1,z1, ...]
              const flatPositions = positions.flat();

              // Create a typed array attribute for positions
              geometry.setAttribute(
                "position",
                new THREE.Float32BufferAttribute(flatPositions, 3),
              );

              // For the faces (indices), you’d collect them in a single index array.
              // Face data is typically triangles, so each face could have 3 (or more) vertices.
              // Example to handle only triangles:
              const indices = [];
              for (const face of faces) {
                // face is something like [{vertexIndex, normalIndex}, ... 3 or 4]
                if (face.length === 3) {
                  // Triangles
                  indices.push(
                    face[0].vertexIndex,
                    face[1].vertexIndex,
                    face[2].vertexIndex,
                  );
                } else if (face.length === 4) {
                  // Example for quad, treat as two triangles:
                  indices.push(
                    face[0].vertexIndex,
                    face[1].vertexIndex,
                    face[2].vertexIndex,
                    face[0].vertexIndex,
                    face[2].vertexIndex,
                    face[3].vertexIndex,
                  );
                }
                // For normalIndex, you'd do something similar if you want to apply normals
              }

              geometry.setIndex(indices);

              // mesh.geometry = BufferGeometryUtils.mergeVertices(
              //   mesh.geometry,
              //   1e-4,
              // );
              geometry.computeVertexNormals();
              // Add the loaded model to the scene
              resolve(geometry);
            });
        }),
    );

    Promise.all(promises)
      .then(model => {
        postProcessFunc(model);
      })
      .catch(error => console.error("Loading failed:", error));
  } else {
    postProcessFunc([new THREE.BufferGeometry(), new THREE.BufferGeometry()]);
  }
  console.log("gum time", Date.now() - startTime);

  ///////////////////////////////////////////////////////////
}

async function loadGumDiffFiles(path, postProcessFunc) {
  const startTime = Date.now();
  const promises = [];
  let diffResult = [];
  // console.log(globalData.maxStepNumber);
  if (false) {
    for (
      let index = 0;
      index <= globalData.maxStepNumber /* tempStepsNum */;
      index++
    ) {
      const pathLower = path + `GingivaLower${index}.diff`;
      const pathUpper = path + `GingivaUpper${index}.diff`;

      const lowerPromise = runDiffViewer(pathLower);
      const upperPromise = runDiffViewer(pathUpper);
      promises.push(Promise.all([lowerPromise, upperPromise]));
      const allResults = await Promise.all(promises);

      // 3) Then build your final diffResult from those resolved values
      diffResult = allResults.map(([lower, upper]) => ({
        lower,
        upper,
      }));
    }
    postProcessFunc(diffResult);
  } else {
    for (
      let index = 0;
      index <= globalData.maxStepNumber /* tempStepsNum */;
      index++
    ) {
      diffResult.push({ lower: undefined, upper: undefined });
    }
    postProcessFunc(diffResult);
  }
  console.log("read Diff file", Date.now() - startTime);
}

function fillTreatmentData(model) {
  const data = model.children[2].userData;

  globalData.upperSteps = data.upper_steps_number;
  globalData.lowerSteps = data.lower_steps_number;

  globalData.isPassiveAligner = data.has_passive;
  globalData.hasAttachments = data.has_attachments; // to be worked

  globalData.hasBiteJump = Boolean(data.bitejump);
  globalData.hasIPR = Boolean(data.ipr_keys.length);
  globalData.hasElastics = Boolean(data.elastics);
  globalData.hasPontics = Boolean(data.pontics);

  globalData.case_id = data.case_id;
  globalData.case_uuid = data.case_uuid;

  globalData.maxStepNumber = Math.max(
    data.upper_steps_number,
    data.lower_steps_number,
  );
}

function parseOBJ(objText) {
  // Arrays to store parsed data
  const positions = [];
  const normals = [];
  // Each face is an array of objects: { vertexIndex, normalIndex }
  const faces = [];

  const lines = objText.split("\n");
  for (let line of lines) {
    line = line.trim();
    if (!line || line.startsWith("#")) {
      // Ignore empty lines or comments
      continue;
    }

    // const parts = line.split(/\s+/);
    const parts = line.split(" ");
    const keyword = parts[0];

    switch (keyword) {
      case "v": {
        // Vertex position
        // 'v x y z'
        const x = parseFloat(parts[1]);
        const y = parseFloat(parts[2]);
        const z = parseFloat(parts[3]);
        positions.push([x, y, z]);
        break;
      }

      case "vn": {
        // Vertex normal
        // 'vn x y z'
        break;
        const nx = parseFloat(parts[1]);
        const ny = parseFloat(parts[2]);
        const nz = parseFloat(parts[3]);
        normals.push([nx, ny, nz]);
        break;
      }

      case "f": {
        // Face
        // A face line may look like: f 1/2/1 2/2/1 3/2/1
        // Each chunk can have up to three indices: vertexIndex/textureIndex/normalIndex
        const faceVertices = parts.slice(1).map(faceString => {
          const indices = faceString.split("/");
          // OBJ indices are 1-based, convert to 0-based
          return {
            vertexIndex: parseInt(indices[0], 10) - 1,
            // textureIndex: indices[1] ? parseInt(indices[1], 10) - 1 : undefined, // if needed
            normalIndex: indices[2] ? parseInt(indices[2], 10) - 1 : undefined,
          };
        });

        faces.push(faceVertices);
        break;
      }

      default:
        // Ignore other keywords (vt, g, o, s, etc.) for simplicity
        break;
    }
  }

  return { positions, normals, faces };
}
